// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"557e5231","703":"b5527b3d"}[chunkId] + ".chunk.js";
};